import { useApplicationHelpers as useLibraryApplicationHelpers } from '@portal/ui-library';
import { Application, Partner, PersonRoleEnum } from 'models/extension-generated';

type ApplicationHelpers = {
  getPartnerById: (id: string) => Partner;
  getPartnersByRole: (role: PersonRoleEnum) => Partner[];
  getSinglePartnerByRole: (role: PersonRoleEnum) => Partner;
  isHolderAlsoPayer: () => boolean;
  isHolderInsured: (partner: Partner) => boolean;
  formatPartnerName: (id: string) => string;
};

export const useApplicationHelpers = (application: Application): ApplicationHelpers => {
  return useLibraryApplicationHelpers(
    application as Parameters<typeof useLibraryApplicationHelpers>[0]
  ) as ApplicationHelpers;
};
